/* global SiteMapContentUrl */
import axios from 'axios';
import { helperConvertApiRoute, axiosErrorHandler } from 'helpers/ApiHelper';
import { fetchFooter } from 'components/Footer/FooterActions';

import routes from '../../../../webpack/local/sitemap.json';

export const FETCH_SITE_CONTENT = 'FETCH_SITE_CONTENT';

function fetchSitemap(isStaticRender) {
  let payload;
  if (isStaticRender) {
    payload = { data: routes };
  } else {
    payload = SiteMapContentUrl
      ? axios.get(helperConvertApiRoute(SiteMapContentUrl)).catch(axiosErrorHandler)
      : [];
  }
  return {
    type: FETCH_SITE_CONTENT,
    payload,
  };
}

export const fetchSiteContent = isStaticRender => dispatch =>
  dispatch(fetchFooter()).then(() => dispatch(fetchSitemap(isStaticRender)));
